export default {
    firstName: "",
    lastName: "", 
    email: "", 
    role: "ClientUser", 
    created_date:"", 
    userType: "Client Admin", 
    isActive:true, 
    customerKeys:[], 
    contractKeys:[], 
    assetTypes:['All'],
    location:[], 
    assets:[], 
    assetsName:[], 
    service:[], 
    equipment:[],
    serviceTypes:[]
}
/**
 
{"name":"user913","email":"user913@natobotics.com","created_date":"","role":"Client User","userType":"1","isActive":true,"customerKeys":[5105317],
"contractKeys":[5153083],"assetTypes":["1"],"location":["1"],
"assets":[],"service":["FQT"]}

 */